import { render, staticRenderFns } from "./PrivateInfo.vue?vue&type=template&id=211317d8&scoped=true&"
import script from "./PrivateInfo.vue?vue&type=script&lang=ts&"
export * from "./PrivateInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PrivateInfo.vue?vue&type=style&index=0&id=211317d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211317d8",
  null
  
)

export default component.exports